import type { HTMLAttributes } from "react";
import clsx from "clsx";

interface LogoProps extends HTMLAttributes<SVGSVGElement> {
  size?: number;
}

export const LogoMark = ({ size = 28, className, ...props }: LogoProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx("shrink-0", className)}
    aria-hidden="true"
    {...props}
  >
    <defs>
      <linearGradient id="ipm-grad" x1="8" y1="8" x2="56" y2="56" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--color-primary)" />
        <stop offset="1" stopColor="var(--color-secondary)" />
      </linearGradient>
    </defs>
    <rect x="6" y="6" width="52" height="52" rx="16" fill="url(#ipm-grad)" />
    <path
      d="M18 31.5L32 20l14 11.5"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.95"
    />
    <path
      d="M22 29.5V44c0 2.2 1.8 4 4 4h12c2.2 0 4-1.8 4-4V29.5"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.95"
    />
    <path
      d="M33.5 36.5c0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2 4.5 4.5 0 2.5-2 4.5-4.5 4.5h-0.6l-2.6 2.3 0.6-2.3c-1.5-0.7-2.4-2.1-2.4-4.0Z"
      fill="white"
      opacity="0.92"
    />
  </svg>
);

export const LogoLockup = ({
  className
}: {
  className?: string;
}) => (
  <div className={clsx("flex items-center gap-2", className)}>
    <LogoMark size={26} />
    <div className="leading-tight">
      <div className="text-xs font-semibold uppercase tracking-[0.18em] text-app-soft">
        Investment Property
      </div>
      <div className="font-semibold">Mate</div>
    </div>
  </div>
);

